import React from 'react';

import { recordEvent } from '../product';
import { AmplitudeContext } from './amplitudeContext';

export type AmplitudeProviderProps = { children: React.ReactNode };

export const AmplitudeProvider = ({ children }: AmplitudeProviderProps) => {
    const value = { recordEvent };

    return <AmplitudeContext.Provider value={value}>{children}</AmplitudeContext.Provider>;
};
